<div id="onboarding-stepper-component">

  <div class="stepper-title">Création d'une communauté</div>

  <div class="container-steps">
    <div *ngFor="let step of steps; let i = index"
         [ngClass]="{'active': i < currentStep}">
    </div>
  </div>
</div>
